const SPEAKERS_LIST = [
    {
        id: "linda",
        name: "Linda",
        gender: "F",
        lang: "English, US",
        styles: [{ name: "Default", id: "default" }],
        source: "lj",
        private: false
    },
    {
        id: "steven",
        name: "Steven",
        gender: "M",
        lang: "English, US",
        styles: [
            { name: "Narration", id: "narration" },
            { name: "Conversational", id: "conversational" },
            { name: "Happy", id: "happy" },
            { name: "Sad", id: "sad" },
            { name: "Scared", id: "scared" },
            { name: "Angry", id: "angry" },
            { name: "Flirty", id: "flirty" },
            { name: "Flustered", id: "flustered" },
            { name: "Whispering", id: "whispering" },
            { name: "Commercial", id: "commercial" },
            { name: "New Yorker", id: "new-yorker" },
            { name: "Robot", id: "robot" }
        ],
        source: "voicery",
        private: false
    },
    {
        id: "katie",
        name: "Katie",
        gender: "F",
        lang: "English, US",
        styles: [
            { name: "Conversational", id: "conversational" },
            { name: "Narration", id: "narration" },
            { name: "Happy", id: "happy" },
            { name: "Sad", id: "sad" },
            { name: "Scared", id: "scared" },
            { name: "Angry", id: "angry" },
            { name: "Flirty", id: "flirty" },
            { name: "Flustered", id: "flustered" },
            { name: "Whispering", id: "whispering" }
        ],
        source: "voicery",
        private: false
    },
    {
        id: "luke",
        name: "Luke",
        gender: "M",
        lang: "English, Australian",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "jason",
        name: "Jason",
        gender: "M",
        lang: "English, US",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "maya",
        name: "Maya",
        gender: "F",
        lang: "English, Indian",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "richard",
        name: "Richard",
        gender: "M",
        lang: "English, British",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "samantha",
        name: "Samantha",
        gender: "F",
        lang: "English, British",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "ashley",
        name: "Ashley",
        gender: "F",
        lang: "English, US",
        styles: [{ name: "Default", id: "default" }],
        source: "voicery",
        private: false
    },
    {
        id: "matthew",
        name: "Matthew",
        gender: "M",
        lang: "English, US",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "chloe",
        name: "Chloe",
        gender: "F",
        lang: "English, US",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "emma",
        name: "Emma",
        gender: "F",
        lang: "English, Canadian",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "arno",
        name: "Arno",
        gender: "M",
        lang: "English, South African",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "mieke",
        name: "Mieke",
        gender: "F",
        lang: "English, South African",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "gavin",
        name: "Gavin",
        gender: "M",
        lang: "English, Scottish",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "mairi",
        name: "Mairi",
        gender: "F",
        lang: "English, Scottish",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "charlie",
        name: "Charlie",
        gender: "M",
        lang: "English, British",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "abigail",
        name: "Abigail",
        gender: "F",
        lang: "English, British",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "sean",
        name: "Sean",
        gender: "M",
        lang: "English, Irish",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "mona",
        name: "Mona",
        gender: "F",
        lang: "English, Irish",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    },
    {
        id: "sebastian",
        name: "Sebastian",
        gender: "M",
        lang: "English, Australian",
        styles: [{ name: "Default", id: "default" }],
        source: "vctk",
        private: false
    }
];
export default SPEAKERS_LIST;
